module.exports = __webpack_public_path__ + "img/food-yellow.d6dee628.svg";